export const LAB_INSTRUCTOR_PERMISSIONS = {
    EDIT_DRAFT: 'labs:edit',
    EDIT_PUBLISHED: 'labs:edit_published',
    EDIT_VERTICAL_TEMPLATE: 'labs:edit_vertical_template',
    MANAGE_INSTRUCTORS: 'labs:manage_instructors',
    REVENUE_REPORT: 'labs:view_lab_revenue_report',
    REPORTED_ISSUES: 'labs:view_reported_issues',
} as const;
